'use strict';

const isInViewport = require('./modules/helpers/isInViewport');
const getTriggerFromHash = require('./modules/util/getTriggerFromHash');
const setLocationHash = require('./modules/util/setLocationHash');
const generateUniqueGuid = require('./modules/util/generateUniqueGuid');
const gtm = require('./modules/google').tagManager;

const $filterBlockSelector = '.js-product-filter-block';
const $filterBlocks = $($filterBlockSelector);
const $filterItemSelector = '.js-filter-item';
const $gridPlaceholderSelector = '.js-filtered-grid-placeholder';
const scrollOffset = 250;
let url = $filterBlocks.prev('.js-filter-block-url').val();

function initialDataLoad(filterBlock) {
    $(document).off('scroll.' + filterBlock.attr('id'));
    const $placeholder = filterBlock.find($gridPlaceholderSelector);
    const hash = getTriggerFromHash() || getTriggerFromDatattribute();
    const $defaultProductFilter = hash ? filterBlock.find('[data-anchor-id=' + hash + ']') : filterBlock.find('.js-product-filters > li:first-child > a');
    $defaultProductFilter.addClass('selected');
    const data = getFilterDataFromElement($defaultProductFilter, $placeholder);
    const pageSize = $placeholder.data('page-size') || 0;
    const stateGridItemCount = (window.history.state && window.history.state.gridItemCount) ? window.history.state.gridItemCount : 0;

    if (pageSize) {
        data.pageSize = pageSize + stateGridItemCount;
    }

    if (!$placeholder.hasClass('is-loaded')) {
        $placeholder.addClass('is-loaded');
        loadProducts(data, $placeholder);
    }
}

function getTriggerFromDatattribute() {
    const dataAttr = $filterBlocks.parent().data('open-tab');
    return typeof dataAttr !== 'undefined' && dataAttr.length > 0 ? 'trigger-' + dataAttr : '';
}

function changeTab(clickedCollection) {
    const $this = $(clickedCollection);
    const $filterBlock = $this.parents($filterBlockSelector);
    $filterBlock.find($filterItemSelector + '.selected').removeClass('selected');
    $this.addClass('selected');
    const $placeholder = $filterBlock.find($gridPlaceholderSelector);
    const data = getFilterDataFromElement($this, $placeholder);
    loadProducts(data, $placeholder);
    setLocationHash($this.data('anchor-id'));
    handleDataLayerEvent($this);
}

function initEvents() {
    $(document).on('click', $filterItemSelector + ':not(.selected)', function () {
        const $this = $(this);
        const $filterBlock = $this.parents($filterBlockSelector);
        $filterBlock.find($filterItemSelector + '.selected').removeClass('selected');
        $this.addClass('selected');
        const $placeholder = $filterBlock.find($gridPlaceholderSelector);
        const data = getFilterDataFromElement($this, $placeholder);
        loadProducts(data, $placeholder);
        setLocationHash($this.data('anchor-id'));
        handleDataLayerEvent($this);
    });

    $(document).on('click', $filterItemSelector + '.selected', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    document.addEventListener('shouldTriggerLazyload', function(e) {
        setTimeout(() => {
            initialDataLoad($('[data-anchor-id=' + e.detail + ']'));
        }, 1000);
    }, false);

    $('.js-product-filter-block').each(function () {
        const $this = $(this);
        const blockId = generateUniqueGuid();
        $this.attr('id', blockId);
        if (isInViewport($this)) {
            initialDataLoad($this);
            return true;
        }

        $(document).on('scroll.' + blockId, function () {
            if ($(window).scrollTop() < scrollOffset) {
                return true;
            }
            initialDataLoad($this);
        });
        return true;
    });
}

function loadProducts(data, placeholder) {
    if (!url) {
        url = 'seeMoreLabel' in data ? Urls.showProductsFilterBlock : Urls.showFilteredGrid;
    }

    $.ajax({
        url: url,
        data: data,
        success: function (products) {
            if (!products) {
                return;
            }
            placeholder.html(products).imagesLoaded(function () {
                const grid = require('./grid');
                grid.init();
            });
        }
    });
}

function getFilterDataFromElement(filterElement, $gridPlaceHolder) {
    const $filterElement = $(filterElement);
    const filters = $filterElement.data('filters');
    const seeMoreLabel = $filterElement.data('see-more-label');
    const includeGWP = $filterElement.data('includeGwp');

    //TODO: Refactor this for a proper difference, without resorting to having a "see more" label to distinguish the filter types
    if (seeMoreLabel) { //"Gifting landing page" product filters: A small grid with a link
        return {
            pageSize: $gridPlaceHolder.data('page-size'),
            category: filters.category,
            minPrice: filters.minPrice,
            maxPrice: filters.maxPrice,
            seeMoreLabel: $filterElement.data('see-more-label')
        };
    } else { //"Collection page" product filters: A proper grid with a "see more" button
        return {
            filters: JSON.stringify(filters),
            includeGWP: includeGWP
        };
    }
}

function handleDataLayerEvent(target){
    if (!target || !target.length) {
        return;
    }
    const analytics = target.data('analytics');
    if (!analytics) {
        return;
    }
    analytics.click_target = decodeURI(analytics.click_target); /* eslint-disable-line camelcase */
    gtm.pushDataLayerEvent(analytics);
}

const productFilters = {
    init: function () {
        initEvents();
    },
    changeTab: function (clickedCollection) {
        changeTab(clickedCollection);
    }
};

module.exports = productFilters;
